// ============================================================================
// SPANISH TRANSLATIONS - CHAPTER 6: LAS MISIONES DE PABLO
// ============================================================================
// Niveles 66-78 (13 niveles, 39 preguntas)

export const chapter6Translations = {
  name: "Las Misiones de Pablo",
  description: "Hasta los confines de la tierra...",
  
  spiritualWisdom: {
    principle: "El Evangelio es para todas las naciones y debe ser anunciado al mundo entero",
    scripture: "Id y haced discípulos a todas las naciones (Mateo 28:19)",
    application: "Cada cristiano está llamado a ser testigo de Cristo donde Dios lo coloque"
  },
  
  levels: {
    66: {
      name: "Primer Viaje Misionero",
      challenge: "Apartadme a Bernabé y a Saulo para la obra a la que los he llamado...",
      easy: {
        question: "¿Quién acompañó a Pablo en su primer viaje?",
        options: ["Pedro", "Bernabé", "Silas", "Timoteo"],
        hint: "El 'hijo de consolación'",
        funFact: "👥 Bernabé había acogido a Pablo después de su conversión - ¡asociación providencial!"
      },
      medium: {
        question: "¿De qué ciudad partieron para su misión?",
        options: [
          "Jerusalén",
          "Antioquía de Siria",
          "Tarso",
          "Damasco"
        ],
        hint: "La primera iglesia mixta de judíos y gentiles",
        funFact: "🚢 Antioquía: ¡puerto de partida de la evangelización del mundo occidental!"
      },
      hard: {
        question: "¿Qué revela este primer viaje sobre la estrategia misionera?",
        options: [
          "Hay que quedarse en su región",
          "El Evangelio trasciende todas las fronteras culturales",
          "Solo los judíos pueden ser salvos",
          "La misión es opcional"
        ],
        hint: "Se trata de la universalidad del mensaje",
        funFact: "🌊 ¡Cruzar el Mediterráneo = dar el paso hacia la evangelización mundial!"
      }
    },
    
    67: {
      name: "En Chipre con Elimas",
      challenge: "Hombre lleno de todo engaño y de toda maldad, hijo del diablo...",
      easy: {
        question: "¿Qué mago se opuso a Pablo en Chipre?",
        options: ["Simón", "Elimas", "Apolos", "Alejandro"],
        hint: "Un falso profeta que quería apartar al procónsul",
        funFact: "🪄 ¡Primer enfrentamiento directo entre el Evangelio y la magia!"
      },
      medium: {
        question: "¿Qué hizo Pablo a Elimas para castigarlo?",
        options: [
          "Lo expulsó",
          "Lo dejó ciego temporalmente",
          "Lo ignoró",
          "Debatió con él"
        ],
        hint: "Una ceguera temporal para abrirle los ojos espirituales",
        funFact: "👁️ ¡Ironía divina: el que cegaba las almas queda temporalmente ciego!"
      },
      hard: {
        question: "¿Cómo ilustra este episodio el poder del Evangelio?",
        options: [
          "La violencia es necesaria",
          "La verdad divina se impone ante la mentira",
          "Hay que combatir a todos los magos",
          "Pablo era vengativo"
        ],
        hint: "Se trata de la autoridad divina frente a la impostura",
        funFact: "⚡ ¡El procónsul cree al ver el poder divino - demostración eficaz!"
      }
    },

    68: {
      name: "En Antioquía de Pisidia",
      challenge: "A vosotros a quienes primero era necesario que se os hablase la palabra de Dios...",
      easy: {
        question: "¿Dónde predicaba Pablo al llegar a una ciudad?",
        options: [
          "En la plaza pública",
          "Primero en la sinagoga",
          "En casa de los ricos",
          "En los templos paganos"
        ],
        hint: "Siempre comenzaba por su pueblo",
        funFact: "🕍 ¡Estrategia misionera: primero a los judíos, luego a los gentiles!"
      },
      medium: {
        question: "¿Cómo reaccionaron los judíos al mensaje de Pablo?",
        options: [
          "Todos lo aceptaron",
          "Estuvieron divididos: algunos creyeron, otros se opusieron",
          "Permanecieron indiferentes",
          "Lo expulsaron inmediatamente"
        ],
        hint: "División clásica ante el Evangelio",
        funFact: "⚖️ ¡El Evangelio siempre divide: aceptación o rechazo, no hay indiferencia!"
      },
      hard: {
        question: "¿Por qué Pablo se vuelve hacia los gentiles?",
        options: [
          "Prefería a los gentiles",
          "El rechazo de los judíos abre la puerta a las naciones",
          "Era más fácil",
          "Abandonaba su misión"
        ],
        hint: "Se trata del cumplimiento profético",
        funFact: "🚪 ¡'Luz de las naciones' - profecía de Isaías cumplida por Pablo!"
      }
    },

    69: {
      name: "Curación en Listra",
      challenge: "¡Los dioses bajo forma humana han descendido a nosotros!",
      easy: {
        question: "¿Qué curó Pablo en Listra?",
        options: [
          "Un ciego",
          "Un paralítico de nacimiento",
          "Un sordomudo",
          "Un leproso"
        ],
        hint: "Alguien que nunca había caminado",
        funFact: "🦵 ¡Milagro espectacular: '¡Levántate derecho sobre tus pies!' - fe sanadora!"
      },
      medium: {
        question: "¿Por quiénes tomó la multitud a Pablo y Bernabé?",
        options: [
          "Reyes",
          "Dioses (Júpiter y Mercurio)",
          "Magos",
          "Profetas"
        ],
        hint: "Divinidades del panteón griego",
        funFact: "⚡ ¡Bernabé = Júpiter (imponente), Pablo = Mercurio (orador) - malentendido cultural!"
      },
      hard: {
        question: "¿Cómo reacciona Pablo ante esta adoración idólatra?",
        options: [
          "Acepta los honores",
          "Rasga sus vestidos y predica al Dios verdadero",
          "Calla por cortesía",
          "Aprovecha la situación"
        ],
        hint: "Rechazo total de la idolatría",
        funFact: "👔 ¡Rasgar las vestiduras = horror judío ante la idolatría - integridad total!"
      }
    },

    70: {
      name: "Lapidación y Resurrección",
      challenge: "Cuando los discípulos lo rodearon, se levantó y entró en la ciudad...",
      easy: {
        question: "¿Qué hicieron los habitantes de Listra a Pablo?",
        options: [
          "Lo encarcelaron",
          "Lo apedrearon",
          "Lo exiliaron",
          "Lo crucificaron"
        ],
        hint: "El castigo tradicional judío",
        funFact: "🪨 ¡De 'dios' a 'muerto' en un día - inconstancia de la multitud humana!"
      },
      medium: {
        question: "¿Qué hizo Pablo después de ser apedreado?",
        options: [
          "Huyó de la ciudad",
          "Se escondió",
          "Se levantó y volvió a entrar en la ciudad",
          "Fue al hospital"
        ],
        hint: "Coraje sobrenatural después de la supuesta muerte",
        funFact: "💪 ¡Resurrección milagrosa o curación divina - coraje increíble!"
      },
      hard: {
        question: "¿Qué revela esta persecución sobre el costo del testimonio?",
        options: [
          "Hay que evitar los conflictos",
          "Testificar por Cristo puede costar la vida",
          "Pablo era imprudente",
          "La persecución es inútil"
        ],
        hint: "Se trata del precio del testimonio auténtico",
        funFact: "✝️ ¡'Es necesario pasar por muchas tribulaciones' - realismo de Pablo!"
      }
    },

    71: {
      name: "El Concilio de Jerusalén",
      challenge: "Si no os circuncidáis, no podéis ser salvos...",
      easy: {
        question: "¿Qué debate importante tuvo lugar en el concilio de Jerusalén?",
        options: [
          "El bautismo",
          "La circuncisión de los gentiles convertidos",
          "El día del sábado",
          "Las ofrendas"
        ],
        hint: "¿Había que hacerse judío para ser cristiano?",
        funFact: "✂️ ¡Primera crisis importante: ¿cristianismo o judeo-cristianismo?"
      },
      medium: {
        question: "¿Cuál fue la decisión final del concilio?",
        options: [
          "Circuncisión obligatoria",
          "Libertad para los gentiles con algunas recomendaciones",
          "Separación total de los judíos",
          "Aplazamiento de la decisión"
        ],
        hint: "Apertura a los gentiles sin restricción importante",
        funFact: "🆓 ¡Revolución histórica: el Evangelio libre de la ley mosaica!"
      },
      hard: {
        question: "¿Qué importancia tiene este concilio para la Iglesia universal?",
        options: [
          "Acontecimiento menor",
          "Establece la universalidad de la salvación solo por la fe",
          "Divide a la Iglesia",
          "Refuerza el legalismo"
        ],
        hint: "Se trata del fundamento de la Iglesia universal",
        funFact: "🌍 ¡Sin esta decisión, el cristianismo habría quedado como una secta judía!"
      }
    },

    72: {
      name: "Segundo Viaje: Timoteo",
      challenge: "Pablo quiso llevárselo consigo y lo circuncidó a causa de los judíos...",
      easy: {
        question: "¿Quién se unió a Pablo como joven colaborador?",
        options: ["Marcos", "Lucas", "Timoteo", "Tito"],
        hint: "El 'hijo amado' de Pablo",
        funFact: "👦 ¡Timoteo: joven prodigio convertido en brazo derecho de Pablo - mentoría exitosa!"
      },
      medium: {
        question: "¿Por qué Pablo circuncidó a Timoteo a pesar de la libertad adquirida?",
        options: [
          "Por obligación legal",
          "Por estrategia misionera entre los judíos",
          "Por tradición",
          "Por error"
        ],
        hint: "Sabiduría práctica para evitar obstáculos",
        funFact: "🎯 ¡Libertad con sabiduría: 'Hacerse todo para todos para ganar a algunos'!"
      },
      hard: {
        question: "¿Cómo ilustra esta actitud la flexibilidad misionera?",
        options: [
          "Pablo era inconstante",
          "Adaptaba su método sin comprometer el Evangelio",
          "Cedía a la presión",
          "Era hipócrita"
        ],
        hint: "Se trata de sabiduría contextual",
        funFact: "⚖️ ¡Principios firmes, métodos flexibles - arte del testimonio eficaz!"
      }
    },

    73: {
      name: "La Visión del Hombre Macedonio",
      challenge: "¡Pasa a Macedonia y ayúdanos!",
      easy: {
        question: "¿Qué vio Pablo en su visión nocturna?",
        options: [
          "Un ángel",
          "Un hombre de Macedonia llamándolo",
          "Jesús hablándole",
          "Una gran luz"
        ],
        hint: "Una llamada de ayuda desde Europa",
        funFact: "🌉 ¡Visión decisiva: el Evangelio cruza a Europa - punto de inflexión histórico!"
      },
      medium: {
        question: "¿Cuál fue la primera ciudad europea evangelizada?",
        options: [
          "Atenas",
          "Corinto",
          "Filipos",
          "Tesalónica"
        ],
        hint: "Colonia romana en Macedonia",
        funFact: "🏛️ ¡Filipos: primera iglesia europea - continente transformado para siempre!"
      },
      hard: {
        question: "¿Qué simboliza esta visión para la historia del cristianismo?",
        options: [
          "Un sueño ordinario",
          "La expansión providencial hacia Occidente",
          "Una alucinación",
          "Un cambio de plan"
        ],
        hint: "Se trata de la Providencia dirigiendo la historia",
        funFact: "🗺️ ¡Sin esta visión, Europa podría haber quedado pagana - plan divino!"
      }
    },

    74: {
      name: "Lidia, Primera Convertida Europea",
      challenge: "El Señor abrió el corazón de Lidia para que estuviera atenta...",
      easy: {
        question: "¿Cuál era el oficio de Lidia?",
        options: [
          "Panadera",
          "Vendedora de púrpura",
          "Tejedora",
          "Alfarera"
        ],
        hint: "Comercio de lujo de la época",
        funFact: "🟣 ¡Púrpura = color real muy costoso - Lidia era próspera!"
      },
      medium: {
        question: "¿Dónde conoció Pablo a Lidia?",
        options: [
          "En el mercado",
          "A la orilla del río durante una oración",
          "En su casa",
          "En la sinagoga"
        ],
        hint: "Un lugar de oración al aire libre",
        funFact: "🏞️ ¡No había sinagoga en Filipos - oración junto al agua según la tradición!"
      },
      hard: {
        question: "¿Qué revela la conversión de Lidia sobre la obra divina?",
        options: [
          "Estaba predispuesta",
          "Dios abre los corazones preparados para recibir su Palabra",
          "Era una coincidencia",
          "Pablo era persuasivo"
        ],
        hint: "Se trata de la acción divina en la conversión",
        funFact: "💝 ¡'El Señor abrió su corazón' - Dios prepara y abre las almas!"
      }
    },

    75: {
      name: "Prisión en Filipos",
      challenge: "A medianoche, Pablo y Silas oraban y cantaban himnos a Dios...",
      easy: {
        question: "¿Por qué fueron encarcelados Pablo y Silas?",
        options: [
          "Robo",
          "Alteración del orden público al expulsar un demonio",
          "Blasfemia",
          "Revuelta"
        ],
        hint: "Curación de una esclava adivina",
        funFact: "💸 ¡Liberar un alma cuesta caro a sus explotadores - persecución económica!"
      },
      medium: {
        question: "¿Qué hicieron Pablo y Silas en la prisión?",
        options: [
          "Se quejaron",
          "Oraban y cantaban",
          "Preparaban su defensa",
          "Durmieron"
        ],
        hint: "Alabanza a pesar de las cadenas",
        funFact: "🎵 ¡Cánticos de alabanza a medianoche en prisión - fe inquebrantable que impresiona!"
      },
      hard: {
        question: "¿Cómo transformó su actitud la situación?",
        options: [
          "No tuvo ningún efecto",
          "Convirtió al carcelero después del terremoto",
          "Molestó a los guardias",
          "Los volvió locos"
        ],
        hint: "Testimonio poderoso por el ejemplo",
        funFact: "🌍 ¡Terremoto + testimonio = conversión del carcelero y su familia!"
      }
    },

    76: {
      name: "En Atenas: El Areópago",
      challenge: "Lo que adoráis sin conocerlo, esto os anuncio yo...",
      easy: {
        question: "¿A qué altar hizo referencia Pablo en Atenas?",
        options: [
          "Al dios Zeus",
          "Al dios desconocido",
          "A Apolo",
          "A Atenea"
        ],
        hint: "Una inscripción misteriosa que sirvió de punto de partida",
        funFact: "🏛️ ¡'Al dios desconocido' - punto de contacto genial con la filosofía griega!"
      },
      medium: {
        question: "¿Ante quiénes predicó Pablo en Atenas?",
        options: [
          "La multitud ordinaria",
          "Los filósofos epicúreos y estoicos en el Areópago",
          "Los sacerdotes de los templos",
          "El emperador romano"
        ],
        hint: "La élite intelectual griega",
        funFact: "🧠 ¡Areópago = Harvard antiguo - Pablo ante los más grandes pensadores!"
      },
      hard: {
        question: "¿Cuál fue la reacción de los atenienses ante la resurrección?",
        options: [
          "Aceptación unánime",
          "División: burla de algunos, interés de otros",
          "Ira general",
          "Indiferencia total"
        ],
        hint: "Reacción típica de los intelectuales ante este misterio",
        funFact: "🤔 ¡Resurrección = piedra de tropiezo para la inteligencia humana orgullosa!"
      }
    },

    77: {
      name: "Corinto: Pablo Fabricante de Tiendas",
      challenge: "Se quedó con ellos y trabajaba, pues eran fabricantes de tiendas...",
      easy: {
        question: "¿Qué oficio practicaba Pablo para ganarse la vida?",
        options: [
          "Pescador",
          "Fabricante de tiendas",
          "Escriba",
          "Comerciante"
        ],
        hint: "Oficio manual que había aprendido",
        funFact: "⛺ ¡Pablo: apóstol-artesano - dignidad del trabajo manual entre los cristianos!"
      },
      medium: {
        question: "¿En casa de quién se alojó Pablo en Corinto?",
        options: [
          "En una posada",
          "En casa de Aquila y Priscila",
          "En casa del gobernador",
          "En la sinagoga"
        ],
        hint: "Una pareja de fabricantes de tiendas como él",
        funFact: "👫 ¡Aquila y Priscila: pareja misionera modelo - hospitalidad cristiana!"
      },
      hard: {
        question: "¿Por qué trabajaba Pablo con sus manos?",
        options: [
          "Solo por necesidad financiera",
          "Para no ser una carga y autenticar su testimonio",
          "Por tradición familiar",
          "Porque le gustaba ese oficio"
        ],
        hint: "Se trata de independencia y credibilidad",
        funFact: "💼 ¡Autonomía financiera = libertad de palabra - Pablo no dependía de nadie!"
      }
    },

    78: {
      name: "Revuelta en Éfeso",
      challenge: "¡Grande es Diana de los efesios!",
      easy: {
        question: "¿Quién provocó la revuelta contra Pablo en Éfeso?",
        options: [
          "Las autoridades romanas",
          "Demetrio el platero y los artesanos",
          "Los filósofos",
          "Los sacerdotes judíos"
        ],
        hint: "Los que fabricaban templos de Diana",
        funFact: "🏛️ ¡Primera huelga de la historia: el Evangelio amenaza la economía idólatra!"
      },
      medium: {
        question: "¿Cuánto tiempo enseñó Pablo en Éfeso?",
        options: [
          "6 meses",
          "1 año",
          "2 años",
          "3 años"
        ],
        hint: "Su estancia misionera más larga",
        funFact: "📅 ¡3 años de enseñanza intensiva - Éfeso se convirtió en centro misionero importante!"
      },
      hard: {
        question: "¿Qué revela esta revuelta sobre el impacto social del Evangelio?",
        options: [
          "El Evangelio no cambia nada",
          "Transforma las estructuras económicas y sociales",
          "Solo concierne a la religión",
          "Evita los conflictos"
        ],
        hint: "Se trata de transformación social profunda",
        funFact: "💰 ¡Cuando el Evangelio avanza, los ídolos pierden su mercado - impacto económico!"
      }
    }
  }
};

export default chapter6Translations;
